
import {  AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { formatDate } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject } from 'rxjs';
import { ApiServiceProject } from 'src/app/web/apis/ApiServiceProject';
import { FormatDataTableGlobal, FormatDataTableGlobalFive } from 'src/app/web/util/formatDataTable';
import { payTemplate } from 'src/app/web/interfaces/project/payments/payments';
import Swal from 'sweetalert2';
import { ErrorService } from 'src/app/shared/services/errors.service';
export function FormatterPeso(): any {
    return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 2
    })
}

export function FormatterDolar(): any {
    return new Intl.NumberFormat('es-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    })
}

export function FormatterPesonNotDecimal(): any {
    return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0
    })
}
@Component({
  selector: 'app-pagosperso',
  templateUrl: './pagosperso.component.html',
  styleUrls: ['./pagosperso.component.scss']
})

export class PagosPersoComponent implements  AfterViewInit, OnDestroy, OnInit  {
  @Input() pagos:payTemplate
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  paymentsform: FormGroup;
  fechasForm: FormGroup;
  dtOptions: DataTables.Settings = {dom:'1.5'};
  idProject
  nameproject
  tipomoneda
  listtype : [{id:number,
               name:string}];
  listapagos:[{description:string,monto:string}];

  items!: FormArray;  

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiServiceProject,
    private errorService:ErrorService
  ) { 
    this.route.params.subscribe((params) => {
      this.idProject = params['id'];
      this.nameproject = params['name'];
    });
  }

  ngOnInit(): void {
    this.spinner.show();
    this.dtOptions = FormatDataTableGlobalFive();
    this.paymentsform = this.fb.group({
      items: new FormArray([])  
    });
    this.selectMoneda()
    for(let i = 0 ; i < this.pagos.listPlay.length; i++){
      let montito = this.pagos.listPlay[i].monto.split(".").join('')
      montito = montito.split(",").join('.')
      this.items = this.paymentsform.get('items') as FormArray;  
      let info = this.fb.group({  
        
          title: this.pagos.listPlay[i].description,
          pay_amount:this.tipomoneda.format(montito),
          amount_percent: Number(100),
          scheduled_date:''
        
      });  

      this.items.push(info);
    }

    
    // this.fechasForm = this.fb.group({
    // });
    // for(let i = 0 ; i < this.pagos.listPlay.length; i++){
    //   this.Paymentsform.addControl('title'+ i, new FormControl(this.pagos.listPlay[i].description));
    //   this.Paymentsform.addControl('scheduled_date'+ i, new FormControl('2020-11-24'));
      
    // }
    this.listapagos = this.pagos.listPlay 
    this.rerender()
    this.spinner.hide();
  }
  selectMoneda(){
      if(this.pagos.playOptionDescription != 'CLP' && this.pagos.playOptionDescription != 'Paraguayo') {
        this.tipomoneda = FormatterPeso()
      }
      else
      {
        this.tipomoneda = FormatterPesonNotDecimal()
      }
    }
  nuevoPago(){
    let contador = this.items.length+1
    let suma=0
    this.items.clear()
    for(let i=0;i < contador;i++){
      let montito = this.pagos.monto.split(".").join('')
      montito = montito.split(",").join('.')
      suma =100 / (contador);
      let info = this.fb.group({  
          title: "",
          pay_amount:this.tipomoneda.format(parseFloat(montito) / (contador)),
          amount_percent:  Math.round(100 / (contador)),
          scheduled_date:''
      });  
    this.items.push(info);

    }
    
     
  }

  validate(info){

  }
  get form() {
    return this.paymentsform.controls;
  }
  deletePay(index){
    this.items.removeAt(index)
    let contador = this.items.length
    this.items.clear()
    for(let i=0;i < contador;i++){
      let montito = this.pagos.monto.split(".").join('')
      montito = montito.split(",").join('.')
      let info = this.fb.group({  
          title: "",
          pay_amount: this.tipomoneda.format(Number(montito) / contador),
          amount_percent: 100 / (contador),
          scheduled_date:''
      });  
    this.items.push(info);

    }
  }
  porcentaje(e: Event ,i){
    const element = e.target as HTMLInputElement
    if(!(Number(element.value) > 0)){
      element.value = "";
      this.items.value[i].pay_amount = "0"
    }else{
      if(Number(element.value) > 100){
        element.value = "100";
      }
      if(Number(element.value) < 0){
        element.value = "0";
      }
      let montito = this.pagos.monto.split(".").join('')
      montito = montito.split(",").join('.')
      let suma = parseFloat(montito)*(parseFloat(element.value))
      let rest = suma/100
      this.items.value[i].amount_percent = Number(element.value)
      this.items.value[i].pay_amount = this.tipomoneda.format(rest);
    }

  }
  formSubmit(){
    let contador = 0
    this.items.value.map((data)=>{
      contador = contador + Number(data.amount_percent)
    })
    // if(contador != 100){
    //   return Swal.fire({title:"El porcentaje total debe ser 100" ,text: '',icon: 'error',heightAuto: false});
    // }
    var form = document.getElementsByClassName('needs-validation')[0] as HTMLFormElement;
    if (form.checkValidity() === false) {
      form.classList.add('was-validated');
    } else {
      if(this.redoVal(contador)){
        this.btnGuardar();
      }

    }

  }
  btnGuardar(){

    this.spinner.show()
    let array = []
    this.items.value.map((d)=>{
      let realStartDateDay =
                d.scheduled_date.split('-')[2];
              let realStartDateMonth =
                d.scheduled_date.split('-')[1];
              let realStartDateYear =
                d.scheduled_date.split('-')[0];
              let realStartDate =
                realStartDateDay +
                '-' +
                realStartDateMonth +
                '-' +
                realStartDateYear;
                let pago=d.pay_amount;
                pago = pago.replace('$','')
      array.push({
        title: d.title,
        pay_amount: pago,
        amount_percent: Number(d.amount_percent),
        scheduled_date: realStartDate
      })
    })
     let post = {
       pay_amount_total:this.pagos.monto,
       projects_id : Number(this.idProject),
       project_attachments_id :0,
       money_type_id:Number(this.pagos.play_option_id),
       templete_id:Number(this.pagos.templete_id),
       listProjectPlayInfo:array
     }
     this.apiService
         .postService('project-play-create', post)
         .subscribe({
           next: (rs: any) => {
            if(rs.code){
               this.spinner.hide();
               Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
             }
             else{
               this.spinner.hide();
               this.spinner.hide()
               Swal.fire({title:rs.message ,text: '',icon: 'success',heightAuto: false}).then(()=>{
                this.router.navigate([`/pdg/project/pay/list/${this.idProject}/${this.nameproject}`]);
               });
           }
           },
           error: (error) => {
             this.errorService.error(error);
           },
         });
    
  }

  redoVal( contador): boolean {
    let por = 0;
    let total = 0
    for(let info of  this.items.value){
      por = por + info.amount_percent
      
      let montito = info.pay_amount.replace('$','')
      montito = montito.split(".").join('')
      montito = montito.split(",").join('.')

      total = total +Number(montito)
    }

    let montito = this.pagos.monto.replace('$','')
    montito = montito.split(".").join('')
    montito = montito.split(",").join('.')

    let totalEndGn = total.toString()
    if(this.pagos.playOptionDescription != 'CLP' && this.pagos.playOptionDescription != 'Paraguayo') {
      totalEndGn = total.toFixed(2).toString()
    }

    let messe = ''
    if(contador != 100){
      messe = "El porcentaje no cumple el 100%. "
    }
    if(totalEndGn != montito){
      messe = messe + " El monto ingresado es diferente al total, "
    }
    messe =  messe+ "¿desea redondear el ultimo item? "

    if(por != 100 && totalEndGn != montito){

      Swal.fire({
        title: 'Alerta',
        text: messe,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'SI',
        cancelButtonText:"NO",
        heightAuto: false
      }).then((res) => {
        if (res.isConfirmed) {

            contador = 100 - contador;

            if(por != 100){
              let i = this.items.value.length
              this.items.value[i-1].amount_percent = Number(this.items.value[i-1].amount_percent) + contador;
            }

            if(totalEndGn != montito){
              let i = this.items.value.length

              let montEnd = this.items.value[i-1].pay_amount.replace('$','')
              montEnd = montEnd.split(".").join('')
              montEnd = montEnd.split(",").join('.')

              let cant =  total - Number(montito) ;

              let endTotal = cant.toFixed(2)

              cant = Number(endTotal) - Number(montEnd)

              if(this.pagos.playOptionDescription != 'CLP' && this.pagos.playOptionDescription != 'Paraguayo') {
                this.items.value[i-1].pay_amount = FormatterPeso().format(cant)

                this.items.value[i-1].pay_amount = this.items.value[i-1].pay_amount.replace('-','')
              }else{
                this.items.value[i-1].pay_amount = FormatterPesonNotDecimal().format(cant)
                this.items.value[i-1].pay_amount = this.items.value[i-1].pay_amount.replace('-','')
              }
            }
            Swal.fire({title:'Exito!',text: 'Se ha moficado con exito! favor validar y guardar',icon: 'success',heightAuto: false});
            return false
        }else{
          return false
        }
      })
      
    }else{
      return true
    }

  }

  // formSubmit(){
  //   let array = []
  //   let arrayfecha = []
  //   let arraytitle = []
  //   for(const property in this.Paymentsform.value) {
  //     if(this.Paymentsform.value[property]== null || this.Paymentsform.value[property] == ''){
  //       return Swal.fire('Por favor rellene todos los campos', '', 'error');
  //     }
  //     let realStartDateDay =
  //               this.Paymentsform.value[property].split('-')[2];
  //             let realStartDateMonth =
  //               this.Paymentsform.value[property].split('-')[1];
  //             let realStartDateYear =
  //               this.Paymentsform.value[property].split('-')[0];
  //             let realStartDate =
  //               realStartDateDay +
  //               '-' +
  //               realStartDateMonth +
  //               '-' +
  //               realStartDateYear;
  //       if(realStartDateYear > 0 ){
  //         arrayfecha.push(realStartDate)
  //       }
  //       else{
  //          arraytitle.push(this.Paymentsform.value[property])
  //       }
  //   }
  //   let i=0
  //   this.pagos.listPlay.map((d)=>{
  //     array.push({
  //       title:arraytitle[i],
  //       scheduled_date:arrayfecha[i],
  //       pay_amount:d.monto,
  //       amount_percent: 0,
  //     })
  //     i=i+1
  //   })
    
  //   let post = {
  //     pay_amount_total:this.pagos.monto,
  //     projects_id : Number(this.idProject),
  //     project_attachments_id :0,
  //     money_type_id:Number(this.pagos.play_option_id),
  //     templete_id:Number(this.pagos.templete_id),
  //     listProjectPlayInfo:array

  //   }
  //   this.apiService
  //       .postService('project-play-create', post)
  //       .subscribe({
  //         next: (rs: any) => {
  //           if(rs.code){
  //             this.spinner.hide();
  //             Swal.fire( rs.error + '', '', 'error');
  //           }
  //           else{
  //             this.spinner.hide();
  //             Swal.fire(rs.message + '', '', 'success');
  //           }
  //         },
  //         error: (error) => {
  //           this.spinner.hide();
  //           Swal.fire({title:  error.error.message +'',text: '',icon: 'error',heightAuto: false});
  //         },
  //       });
  // }

   ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    
  }
}
